<template>
  <div class="product">
    <van-search background="#F2F2F2" v-model="value" placeholder="请输入搜索关键词" @input="onSearch" />
    <div style="border-bottom: 1px solid #EBEBEB;"> </div>
    <div class="product_content">
      <ul class="product_left">
        <li v-for="(item, index) in list" :key="index" :class="{ active: index == activeKey }" @click="activeKey = index">
          {{ item.name }}
          <van-badge v-if="item.val != 0" :content="item.val" class="badge">
          </van-badge>
        </li>
      </ul>
      <div class="product_right">
        <ul class="list" v-for="(item, i)  in  filterList " :key="i">
          <li>
            <img :src="require('../../assets/product/' + item.img)">
          </li>
          <li class="title">{{ item.content }}</li>
          <li class="price">
            <div>
              {{ item.price }}
            </div>
            <div>
              {{ item.user }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import listJson from './product.json'
export default {
  data() {
    return {
      activeKey: 0,
      value: "",
      list: [
        {
          name: '网络足迹筛查',
          val: 0,
          type: 1,
          list: []
        },
        {
          name: '手机查证',
          val: 0,
          type: 2,
          list: []
        },
        {
          name: '手机发现',
          val: 0,
          type: 3,
          list: []
        },
        {
          name: '安全管控',
          val: 0,
          type: 4,
          list: []
        },
        {
          name: '心理筛查',
          val: 0,
          type: 5,
          list: []
        },
        {
          name: '大数据平台',
          val: 0,
          type: 6,
          list: []
        },
        {
          name: '网络信息云服务',
          val: 0,
          type: 7,
          list: []
        },
      ],
      dataList: []
    }
  },
  mounted() {
    this.dataList = listJson;
  },
  computed: {
    filterList() {
      let list = this.dataList.filter(item => item.type == this.activeKey + 1);
      return list;
    }
  },

  methods: {
    onSearch() {
      this.dataList = listJson.filter(item => item.content.includes(this.value));
      for (let i = 0; i < this.list.length; i++) {
        if (this.value) {
          this.list[i].val = this.dataList.filter(item => item.type == i + 1).length;
        } else {
          this.list[i].val = 0;
        }
      }
      // 查询this.list每一项中val不为0并返回第一个索引
      if (this.value) {
        this.activeKey = this.list.findIndex(item => item.val != 0);
      } else {
        this.activeKey = 0;
      }

    }
  }
}
</script>
<style lang="less" scoped>
.product {
  height: 88vh;


  .product_content {
    display: flex;
    height: 100%;
    background-color: rgba(242, 242, 242, 1);

    .product_left {
      width: 32%;
      background-color: rgba(230, 228, 228, 1);
      height: 100%;

      li {
        margin: 10px 0;
        padding: 10px;
        position: relative;

        .badge {
          position: absolute;
          top: -5px;
          right: 0;
        }

      }

      .active {
        background-color: #fff;
      }
    }
  }

  .product_right {
    width: 68%;
    height: 90%;
    padding: 10px;
    overflow-y: auto;

    .list {
      width: 90%;
      margin: 0 auto;
      margin-top: 10px;

      li {
        width: 100%;
        text-align: center;
        line-height: 20px;
        font-size: 0.14rem;

        img {
          width: 100%;
        }
      }

      .title {
        //文字超出2行溢出显示。。。
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        color: rgb(108, 108, 108);
      }

      .price {
        display: flex;
        justify-content: space-between;
        color: red;
      }
    }
  }
}
</style>